/* ═══════════════════════════════════════════════════════════════
   ALTERLY — Stable ID Generation
   Cryptographically collision-free, deterministic prefixes,
   zero mutable global counters.
   ═══════════════════════════════════════════════════════════════ */

export function generateStableId(
  prefix: 'node' | 'edge' | 'port' | 'graph' | 'cmd' | 'proj' | 'img' | 'frame'
): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}_${crypto.randomUUID()}`;
  }
  // Safe fallback if crypto.randomUUID is unavailable in older test environments
  const randomPart = Math.random().toString(36).slice(2, 10);
  const timePart = Date.now().toString(36).slice(-4);
  return `${prefix}_${timePart}${randomPart}`;
}
